/* @flow */

import formatarReal from '../../utils/formatar-real';

type Param = {
    totalCost: string,
    totalEta: number,
};

const viewLoggi = ({
    totalCost,
    totalEta,
}: Param) => `
    <label for="loggi-atendimento" style="min-width: 300px">
        Loggi:
        <input type="checkbox" id="loggi-atendimento" class="checker">
        <div class="row">
            <div class="col">
                <p>
                    Custo da entrega
                    <br/>
                    R$ ${formatarReal(totalCost)}
                </p>
            </div>
            <div class="col">
                <p>
                    Entregue em
                    <br/>
                    ${(totalEta / 60).toFixed()}min
                </p>
            </div>
        </div>
    </label>
    `;

export default viewLoggi;
